import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import Info from '../views/Info'
import Play from '../components/Play'
import Gallery from '../components/Gallery'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    components: {
      default: Play,
      info: Home
    }
  },
  {
    path: '/gallery',
    name: 'Gallery',
    components: {
      default: Gallery,
      info: Home
    }
  },
  {
    path: '/info',
    name: 'Info',
    components: {
      default: Play,
      info: Info
    }
  },
  // {
  //   path: '/pong',
  //   name: 'Pong',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Pong.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // ...
  // console.log(to.path)
  if (window.gtag) {
    window.gtag('config', 'UA-84126832-5', {'page_path': to.path});
  }
  next()
})

export default router
